import { Controller } from '@hotwired/stimulus'

/**
 * This controller removes the 'readonly' attribute from a field
 * when it gains focus.
 *
 * Usage in HTML:
 *
 * <div data-controller="remove-readonly-on-focus">
 *   <input type="text" readonly data-action="focus->remove-readonly-on-focus#remove">
 *   <input type="date" readonly data-action="focus->remove-readonly-on-focus#remove">
 * </div>
 */
export default class extends Controller {
  remove(event) {
    event.currentTarget.removeAttribute('readonly')
  }
}
